import "./App.css";
import Header from "./Shared/Header";
import Footer from "./Shared/Footer";
import { Outlet } from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop";
import ScrollMemory from "./Components/ScrollHandler"; 
function App() {
  return (
    <div className="App">
      {/* <ScrollToTop /> */}
      <ScrollMemory/>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default App;
